import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataPointService } from 'src/app/project/shared/services/datapoint.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { PixelSpaltenResults } from '../../../shared/data-end-channel-settings-dialog/interfaces/pixel-spalten-results';

@Component({
  selector: 'avs-pixel-fehler-dialog',
  standalone: false,
  templateUrl: './pixel-fehler-dialog.component.html',
  styleUrl: './pixel-fehler-dialog.component.css'
})

export class PixelFehlerDialogComponent implements OnInit {
  public pixelSpaltenResults: PixelSpaltenResults[] = [];
  public imageWidth = 0;
  public imageHeight = 0;
  public imageWidthArray: any[] = [];
  public imageHeightArray: any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public alertService: AlertService,
    private dataPointService: DataPointService) { }

  public ngOnInit(): void {
    this.dataPointService.getRouteStationPixelErrors(this.data.guid, this.data.dataEndChannel.de, 30).subscribe((response) => {
      this.imageWidth = response.resolutionX;
      this.imageHeight = response.resolutionY;
    
      this.pixelSpaltenResults = response.pixelSpaltenResults;
      this.imageWidthArray = this.range(this.imageWidth);
      this.imageHeightArray = this.range(this.imageHeight);
    });
  }

  public checkIfPixelErrorExists(x: number, y: number, pixelfehler: any[]): boolean {
    return pixelfehler[x] >= y;
  }

  public range(length: number): number[] {
    return Array.from({ length }, (_, i) => i + 1);
  }

}
